import { useState } from "react";
import { Copy, Check, Mail } from "lucide-react";

const PARTS = ["founders", "x1025.com"];

export const RevealEmail = ({ label = "Prefer email? Show our address", className = "", testId = "reveal-email" }) => {
  const [shown, setShown] = useState(false);
  const [copied, setCopied] = useState(false);
  const address = PARTS.join("@");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (e) {
      setCopied(false);
    }
  };

  if (!shown) {
    return (
      <button
        type="button"
        onClick={() => setShown(true)}
        className={`group inline-flex items-center gap-2 text-sm text-fg-2 hover:text-fg transition-colors ${className}`}
        data-testid={`${testId}-button`}
      >
        <Mail className="h-4 w-4 text-fg-3 group-hover:text-signal transition-colors" />
        <span className="underline decoration-white/20 underline-offset-4 group-hover:decoration-signal">{label}</span>
      </button>
    );
  }

  return (
    <span className={`inline-flex items-center gap-3 text-sm ${className}`} data-testid={`${testId}-address`}>
      <Mail className="h-4 w-4 text-signal" />
      <a href={`mailto:${address}`} className="text-fg underline decoration-signal/60 underline-offset-4">{address}</a>
      <button type="button" onClick={copy} className="text-fg-3 hover:text-fg transition-colors" aria-label="Copy email address" data-testid={`${testId}-copy`}>
        {copied ? <Check className="h-4 w-4 text-signal" /> : <Copy className="h-4 w-4" />}
      </button>
    </span>
  );
};
